import type { SearchResultSection } from './distribute.types';

export const distributeBetweenSections = <T>(
	sections: SearchResultSection<T>[],
	totalSlots: number
): T[][] => {
	const count = sections.length;

	if (count === 0) return [];

	const base = Math.floor(totalSlots / count);
	const extra = totalSlots % count;

	const counts = sections.map((sec, i) =>
		Math.min(sec.items.length, base + (i < extra ? 1 : 0))
	);

	let unused = counts.reduce(
		(sum, count, i) => sum + (base + (i < extra ? 1 : 0) - count),
		0
	);

	for (const [i, sec] of sections.entries()) {
		if (unused === 0) break;

		const free = sec.items.length - counts[i];
		const take = Math.min(free, unused);

		counts[i] += take;
		unused -= take;
	}

	return counts.map((count, i) => sections[i].items.slice(0, count));
};
